/**
 * Enum-like object representing various permissions within the system.
 * Each permission corresponds to a specific action that can be performed.
 *
 * @readonly
 * @enum {string}
 */
export const PERMISSIONS = {
  /** Permission to onboard a new device */
  ADD_DEVICE: 'ADD_DEVICE',

  /** Permission to amend an agreement */
  AMEND_AGREEMENT: 'AMEND_AGREEMENT',

  /** Permission to approve or reject an agreement */
  APPROVE_REJECT_AGREEMENT: 'APPROVE_REJECT_AGREEMENT',

  /** Permission to delete an agreement */
  DELETE_AGREEMENT: 'DELETE_AGREEMENT',

  /** Permission to generate an invoice using the web interface */
  GENERATE_INVOICE: 'GENERATE_INVOICE',

  /** Permission to manage points of contact */
  MANAGE_POINTS_CONTACTS: 'MANAGE_POINTS_CONTACTS',

  /** Permission to manage receipt of emails and/or SMS */
  MANAGE_RECEIPT: 'MANAGE_RECEIPT',

  /** Permission to renew a device (CSID) */
  RENEW_DEVICE: 'RENEW_DEVICE',

  /** Permission to report a technical failure */
  REPORT_FAILURE: 'REPORT_FAILURE',

  /** Permission to resolve a reported technical failure */
  RESOLVE_FAILURE: 'RESOLVE_FAILURE',

  /** Permission to revoke a CSID */
  REVOKE: 'REVOKE',

  /** Permission to submit a special billing agreement */
  SUBMIT_AGREEMENT: 'SUBMIT_AGREEMENT',

  /** Permission to view the list of special billing agreements */
  VIEW_AGREEMENT: 'VIEW_AGREEMENT',

  /** Permission to view core invoices */
  VIEW_CORE_INVOICE_LIST: 'VIEW_CORE_INVOICE_LIST',

  /** Permission to view the invoice dashboard */
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',

  /** Permission to view the list of devices (CSIDs) */
  VIEW_DEVICE: 'VIEW_DEVICE',

  /** Permission to view the list of invoices generated by the web */
  VIEW_INVOICE_LIST: 'VIEW_INVOICE_LIST',

  /** Permission to download invoice statements */
  VIEW_INVOICE_STATEMENT: 'INVOICE_CORE_STATEMENT',

  /** Permission to view the list of reported failures */
  VIEW_REPORTED_FAILURES: 'VIEW_REPORTED_FAILURES',
};

export const havePermission = (permissions, permission) => {
  return permissions?.includes(permission);
};
